'use client';

import { useCustomizationsContext } from '@/app/customizations-provider';
import { Faq, FaqCategories } from '@/app/types/faq';
import { Accordion, AccordionItem } from '@heroui/react';
import Image from 'next/image';

type FaqAccordionProps = {
  tag: FaqCategories;
  faqs: Faq[];
};

const FaqAccordion = ({ tag, faqs }: FaqAccordionProps) => {
  const c = useCustomizationsContext();
  const image = c('faq.arrow');

  const indicator = (
    <Image
      src={image.url}
      alt={image.description}
      height={image.height}
      width={image.width}
      className="transition-transform"
    />
  );
  const filteredFaqs = faqs.filter((faq) => faq.category == tag);

  return (
    <Accordion
      className="bg-accent rounded-3xl divide-[rgba(0,0,0,0.10)]"
      itemClasses={{
        base: 'text-left',
        trigger:
          'flex items-center justify-between px-4 py-[24px] min-h-[71px] md:min-h-[81px] text-left',
        title:
          'font-bold text-left text-xl md:text-[25px] pr-4 font-montserrat',
        indicator: 'data-[open=true]:-rotate-180',
        content: 'text-[16px] md:text-xl pb-6 px-4',
      }}
    >
      {filteredFaqs.map((faq) => (
        <AccordionItem
          key={faq.question}
          title={faq.question}
          indicator={indicator}
        >
          <p>{faq.answer}</p>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordion;
